import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CommonApiService } from 'src/app/services/common-api-service';
import { EventService } from 'src/app/services/event.service';
import { PopupService } from 'src/app/services/popup.service';
import { API_Const } from 'src/app/shared/constants/apiRouteConst';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnDestroy {
  @Output() authenticated = new EventEmitter();
  loginForm: FormGroup;
  subscriptions: Subscription[] = [];
  accessToken: any;
  hidePassword = true;
  wrongPassword = false;

  constructor(private apiService: CommonApiService,
    private popupService: PopupService,
    private fb: FormBuilder,
    private eventService: EventService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required,
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')
      ]],
      password: ['', Validators.required],
    });
    this.loginForm.valueChanges.subscribe({
      next: () => {
        if (this.wrongPassword) {
          this.wrongPassword = false;
        }
      }
    })
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  login() {
    const requestBody = {
      email: this.loginForm.value.email,
      password: this.loginForm.value.password,
    };
    this.eventService.showSpinner();
    this.subscriptions.push(
      this.apiService.post(API_Const.login, requestBody).subscribe(
        (res: any) => {
          this.eventService.hideSpinner();
          if (res.result.statusCode == 200) {
            this.popupService.messsageAlert('success', 'Login Successful!')
            this.authenticated.emit();
          } else {
            this.popupService.messsageAlert('error', res.message);
          }
        },
        (err) => {
          this.eventService.hideSpinner();
          this.popupService.messsageAlert('error', (typeof err?.error?.result === 'string') ? (err.error.result) : err.error.message);
          this.wrongPassword = true;
        }
      )
    );
  }

}
